import './App.css';
import Footer from './components/Footer/Footer';
import Main from './components/Main/Main';
import Nav from './components/Nav/Nav';
import { useLocation } from 'react-router-dom';
import Popular_Cabs from './components/Popular_cabs/Popular_cabs';
import Start_tour from './components/Start_tour/Start_tour';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Choose_floor from './Pages/Choose_floor';
import Firstfloor from './Pages/Firstfloor/Firstfloor';
import Secondfloor from './Pages/Secondfloor/Secondfloor';
import Thirdfloor from './Pages/Thirdfloor/Thirdfloor';
import Aboutschool from './Pages/Aboutschool/Aboutschool';
import Contacts from './Pages/Contacts/Contacts';
import { useEffect } from 'react';
import CabinetPage from './Pages/Cabinetpage1/Cabinetpage.jsx';
import CabinetPage2 from './Pages/Cabinetpage2/Cabinetpage.jsx';
import CabinetPage3 from './Pages/Cabinetpage3/Cabinetpage.jsx';
import CabinetPage4 from './Pages/Cabinetpage4/Cabinetpage.jsx';
import Easteregg from './Pages/EasterEgg/EasterEgg.jsx';
import Page404 from './Pages/404/Page404.jsx';

// Функция регистрации Service Worker
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service Worker registered with scope:', registration.scope);
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  }
};

function App() {
  // Регистрируем Service Worker при загрузке приложения
  useEffect(() => {
    registerServiceWorker();
  }, []);

  function ScrollToTop() {
    const location = useLocation();
  
    useEffect(() => {
      window.history.scrollRestoration = 'manual';
      window.scrollTo(0, 0);
    }, [location]);
  
    return null;
  }

  return (
    <Router> 
      <ScrollToTop/>
      <div className="App">
        <Nav /> 
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Main />
                <Popular_Cabs />
                <Start_tour />
                <Footer />
              </>
            }
          />
          <Route path="/Choose_floor" element={<Choose_floor />} />
          <Route path='/First_floor' element={<Firstfloor/>}/>
          <Route path='/Secondfloor' element={<Secondfloor/>}/>
          <Route path='/Thirdfloor' element={<Thirdfloor/>}/>
          <Route path='/About_school' element={<Aboutschool/>}/>
          <Route path='/Contacts' element={<Contacts/>}   />  
          <Route path='/Dinning_room' element={<CabinetPage/>} />
          <Route path='/Chill_room' element={<CabinetPage2/>}/>
          <Route path='/Library' element={<CabinetPage3/>}/>
          <Route path='/Zal' element={<CabinetPage4/>}/>  
          <Route path='/Easteregg' element={<Easteregg/>}/> 
          <Route path='*' element={<Page404/>}/>      
        </Routes>
      </div>
    </Router>
  );
}

export default App;